import { render } from "./TaskDetails.vue?vue&type=template&id=df862ebc"
import script from "./TaskDetails.vue?vue&type=script&lang=ts"
export * from "./TaskDetails.vue?vue&type=script&lang=ts"
script.render = render

export default script